/** 业务管理页面路由配置 */
export const bizPageRoutes = [
  { path: 'member/list', title: '会员列表', module: '会员管理', apiPrefix: '/admin/fx/member', component: 'member-list' },
  { path: 'member/bind', title: '归因记录', module: '会员管理', apiPrefix: '/admin/fx/member', component: 'member-bind' },
  { path: 'distributor/list', title: '分销商列表', module: '分销管理', apiPrefix: '/admin/fx/distributor', component: 'distributor-list' },
  { path: 'distributor/qrcode', title: '推广二维码', module: '分销管理', apiPrefix: '/admin/fx/distributor', component: 'distributor-qrcode' },
  { path: 'distributor/rule', title: '分销规则', module: '分销管理', apiPrefix: '/admin/fx/distributor', component: 'distributor-rule' },
  { path: 'distributor/settlement', title: '分红结算', module: '分销管理', apiPrefix: '/admin/fx/distributor', component: 'distributor-settlement' },
  { path: 'order/commission', title: '分红流水', module: '分销管理', apiPrefix: '/admin/fx/order', component: 'order-commission' },
  { path: 'distributor/wallet', title: '分销商钱包', module: '分销管理', apiPrefix: '/admin/fx/distributor', component: 'distributor-wallet' },
  { path: 'distributor/withdraw', title: '提现审核', module: '分销管理', apiPrefix: '/admin/fx/distributor', component: 'distributor-withdraw' },
  { path: 'product/category', title: '商品分类', module: '商品管理', apiPrefix: '/admin/fx/product', component: 'product-category' },
  { path: 'product/list', title: '商品列表', module: '商品管理', apiPrefix: '/admin/fx/product', component: 'product-list' },
  { path: 'product/gift-voucher', title: '礼券列表', module: '商品管理', apiPrefix: '/admin/fx/gift-voucher', component: 'gift-voucher-list' },
  { path: 'article/media', title: '媒体库', module: '资讯管理', apiPrefix: '/admin/fx/media', component: 'article-media' },
  { path: 'article/list', title: '资讯列表', module: '资讯管理', apiPrefix: '/admin/fx/article', component: 'article-list' },
  { path: 'article/shop-column', title: '商城专栏', module: '资讯管理', apiPrefix: '/admin/fx/shop-column', component: 'shop-column-list' },
  { path: 'order/list', title: '订单列表', module: '订单管理', apiPrefix: '/admin/fx/order', component: 'order-list' },
  { path: 'order/fulfillment', title: '订单发货', module: '订单管理', apiPrefix: '/admin/fx/order/fulfillment', component: 'order-fulfillment' },
  { path: 'order/payment', title: '支付记录', module: '订单管理', apiPrefix: '/admin/fx/order', component: 'order-payment' },
  { path: 'order/refund', title: '退款管理', module: '订单管理', apiPrefix: '/admin/fx/order', component: 'order-refund' },
  { path: 'order/delivery', title: '物流管理', module: '订单管理', apiPrefix: '/admin/fx/order/logistics/plan', component: 'order-delivery' },
  { path: 'order/shipment', title: '权益发货', module: '订单管理', apiPrefix: '/admin/fx/order/benefit-delivery', component: 'order-shipment' },
  { path: 'stock/lock', title: '库存预占', module: '库存管理', apiPrefix: '/admin/fx/stock', component: 'stock-lock' },
  { path: 'stock/log', title: '库存流水', module: '库存管理', apiPrefix: '/admin/fx/stock', component: 'stock-log' },
  { path: 'system/config', title: '参数配置', module: '业务参数', apiPrefix: '/admin/fx/system', component: 'system-config' },
];

const bizPageComponentMap = {
  'member-list': () => import('../views/biz/member/member-list.vue'),
  'member-bind': () => import('../views/biz/member/member-bind.vue'),
  'article-list': () => import('../views/biz/article/article-list.vue'),
  'article-media': () => import('../views/biz/article/article-media.vue'),
  'shop-column-list': () => import('../views/biz/article/shop-column-list.vue'),
  'system-config': () => import('../views/biz/system/system-config.vue'),
  'product-list': () => import('../views/biz/product/product-list.vue'),
  'gift-voucher-list': () => import('../views/biz/product/gift-voucher-list.vue'),
  'product-category': () => import('../views/biz/product/product-category.vue'),
  'distributor-list': () => import('../views/biz/distributor/distributor-list.vue'),
  'distributor-rule': () => import('../views/biz/distributor/distributor-rule.vue'),
  'distributor-qrcode': () => import('../views/biz/distributor/distributor-qrcode.vue'),
  'distributor-wallet': () => import('../views/biz/distributor/distributor-wallet.vue'),
  'distributor-withdraw': () => import('../views/biz/distributor/distributor-withdraw.vue'),
  'distributor-settlement': () => import('../views/biz/distributor/distributor-settlement.vue'),
  'order-list': () => import('../views/biz/order/order-list.vue'),
  'order-fulfillment': () => import('../views/biz/order/order-fulfillment.vue'),
  'order-payment': () => import('../views/biz/order/order-payment.vue'),
  'order-refund': () => import('../views/biz/order/order-refund.vue'),
  'order-delivery': () => import('../views/biz/order/order-delivery.vue'),
  'order-shipment': () => import('../views/biz/order/order-shipment.vue'),
  'order-commission': () => import('../views/biz/order/order-commission.vue'),
  'stock-lock': () => import('../views/biz/stock/stock-lock.vue'),
  'stock-log': () => import('../views/biz/stock/stock-log.vue')
};

export function buildBizChildrenRoutes() {
  return bizPageRoutes.map(item => ({
    path: item.path,
    name: `biz-${item.path.replace(/\//g, '-')}`,
    component: item.component && bizPageComponentMap[item.component]
        ? bizPageComponentMap[item.component]
        : () => import('../views/biz/biz-placeholder.vue'),
    meta: {
      loginRequire: true,
      title: item.title,
      module: item.module,
      apiPrefix: item.apiPrefix
    }
  }));
}
